import React, { PureComponent } from 'react';
import Slider from 'react-slick';
import { ContentFocusedLACard } from 'appSrc/components/List-Article';
import { Icon, VariableLink } from 'appSrc/components/UI';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

const carouselOptions = {
    infinite: false,
    lazyLoad: 'progressive',
    swipeToSlide: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint:840,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint:480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

class ContentFocusedCardCarousel extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            atBeginning: true,
            atEnd: false,
        };
    }
    componentDidMount() {
        if( this._slider ) {
            var atZero = true;
            var overLimit = this._slider.props.slidesToShow >= this._slider.props.children.length;
            if( atZero && overLimit ) {
                this.setState( { atBeginning: true, atEnd: true } );
            } else if( atZero ) {
                this.setState( { atBeginning: true, atEnd: false } );
            } else if( overLimit ) {
                this.setState( { atBeginning: false, atEnd: true } );
            } else {
                this.setState( { atBeginning: false, atEnd: false } );
            }
        }
    }
    slickNext = () => {
        this._slider && this._slider.slickNext();
    }
    slickPrev = () => {
        this._slider && this._slider.slickPrev();
    }
    beforeChange = ( oldIndex, newIndex ) => {
        var atZero = newIndex == 0;
        var overLimit = newIndex + this._slider.props.slidesToShow >= this._slider.props.children.length;
        if( atZero && overLimit ) {
            this.setState( { atBeginning: true, atEnd: true } );
        } else if( atZero ) {
            this.setState( { atBeginning: true, atEnd: false } );
        } else if( overLimit ) {
            this.setState( { atBeginning: false, atEnd: true } );
        } else {
            this.setState( { atBeginning: false, atEnd: false } );
        }
    }
    render() {
        const { carousel } = this.props;
        const content = carousel.content || [];

        return (
            <div className={ `${ style.contentFocusedCardCarousel } ${ this.props.className }`.trim() }>
                { content.length > 0 &&
                    <div className={ style.carouselWrapper }>
                        { carousel.title &&
                            <div className={ 'carousel-title-bar ' + style.carouselTitleBar }>
                                <h2>{ carousel.title }</h2>
                                { carousel.link_url &&
                                    <VariableLink to={ carousel.link_url }>{ carousel.link_text || 'See All' }</VariableLink>
                                }
                            </div>
                        }
                        <Slider { ...carouselOptions } ref={ ( el ) => { this._slider = el; } }
                        beforeChange={ this.beforeChange }>
                            { content.map( ( item ) => {
                                return (
                                    <div className={ style.cardWrapper } key={ `content-focused_card_carousel\-${ carousel.id }--${ item.type }-${ item.listid }` }>
                                        <ContentFocusedLACard item={ item } />
                                    </div>
                                );
                            } ) }
                        </Slider>
                    </div>
                }
                { content.length > 0 &&
                    <div className={ style.controls }>
                        <Icon source='customSvg' icon='carousel-prev' size={ 60 } onClick={ this.slickPrev }
                        disabled={ this.state.atBeginning } />
                        <Icon source='customSvg' icon='carousel-next' size={ 60 } onClick={ this.slickNext }
                        disabled={ this.state.atEnd } />
                    </div>
                }
            </div>
        );
    }
}
ContentFocusedCardCarousel.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
ContentFocusedCardCarousel.defaultProps = {
    className: '',
    carousel: {},
};

export default ContentFocusedCardCarousel;
